document.addEventListener("DOMContentLoaded", () => {
    const copyButton = document.querySelector('.share-button.link');

    if (copyButton !== null) {
        copyButton.addEventListener("click", function() {
            let urlToCopy = "";

            try {
                urlToCopy = JSON.parse(copyButton.getAttribute("data-share-url"));
            } catch (e) {
                urlToCopy = "";
            }

            if (urlToCopy === "") {
                return;
            }

            if (navigator.clipboard) {
                // Use the Clipboard API if available (modern browsers).
                navigator.clipboard.writeText(urlToCopy)
                .then(() => {
                    copyButton.classList.add('copied');

                    setTimeout(function() {
                        copyButton.classList.remove('copied');
                    }, 3000);
                })
                .catch(err => {
                    
                });
            } else {
                // Fallback for browsers that don't support the Clipboard API.
                const textArea = document.createElement('textarea');
                textArea.value = urlToCopy;
                document.body.appendChild(textArea);
                textArea.select();

                try {
                const successful = document.execCommand('copy');
                
                if (successful) {
                    copyButton.classList.add('copied');

                    setTimeout(function() {
                        copyButton.classList.remove('copied');
                    }, 3000);
                }

                } catch (err) {
                
                }

                document.body.removeChild(textArea);
            }
        });
    }
});